import React from 'react';

function CsirtPage() {
    return (
        <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white px-6 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
                CSIRT PT Len Telekomunikasi Indonesia
            </h1>
            <p className="max-w-xl text-gray-300 mb-8 leading-relaxed">
                Tim CSIRT (Computer Security Incident Response Team) bertugas menangani
                insiden keamanan siber di lingkungan PT Len Telekomunikasi Indonesia.
                Unduh kunci publik PGP kami untuk melaporkan insiden secara aman.
            </p>
            <a
                href="/csirt-pgp.asc"
                download
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition-all duration-200"
            >
                Unduh PGP Public Key (csirt-pgp.asc)
            </a>
            <footer className="mt-12 text-sm text-gray-500">
                © {new Date().getFullYear()} PT Len Telekomunikasi Indonesia. All rights reserved.
            </footer>
        </div>
    );
}

export default CsirtPage;
